import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const HabitatDeleteModal = ({ showDelete, name, setShowDelete, handleRemoveHabitat }) => {
  return (
    <Modal
      size="lg"
      show={showDelete}
      onHide={() => setShowDelete(false)}
      aria-labelledby="modal-remove"
    >
      <Modal.Header>Remove Habitat</Modal.Header>
      <Modal.Body>Are you sure to delete this Habitat?</Modal.Body>
      <Modal.Footer>
        <Button size="sm" onClick={() => handleRemoveHabitat()}>
          Yes
        </Button>
        <Button size="sm" variant="danger" onClick={() => setShowDelete(false)}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HabitatDeleteModal;
